import React from "react";
import Header from "../home/header";
import Footer from "../home/footer";
import arrowtopoutline from '../../images/arrow-top-outline.svg';
import saveoutline from '../../images/save-outline.svg';
import heartoutline from '../../images/heart-outline.svg';
import save from '../../images/save.svg'
import frame from '../../images/frame.png';
import photo1 from '../../images/photo1.png';
import photo2 from '../../images/photo2.png';
import photo3 from '../../images/photo3.png';
import photo4 from '../../images/photo4.png';
import photo5 from '../../images/photo5.png';
import photo6 from '../../images/photo6.png';
import photo7 from '../../images/photo7.png';
import location from '../../images/location.svg';
import brochure from '../../images/brochure.svg';
import floorplan from '../../images/floor-plan.svg';
import website from '../../images/website.svg';
import strip from '../../images/strip.svg';
import bedroom from '../../images/bedroom.svg';
import bathroom from '../../images/bathroom.svg';
import sqft from '../../images/sqft.svg';
import profile_img from '../../images/profile_img.svg';
import comment from '../../images/comment.svg';
import profile_with_v from '../../images/profile_with_v.svg';
import strip_2 from '../../images/strip_2.svg';
import armani1 from '../../images/armani1.svg';
import armani2 from '../../images/armani2.svg';
import armani3 from '../../images/armani3.svg';
import armani4 from '../../images/armani4.svg';
import armani5 from '../../images/armani5.svg';
import armani6 from '../../images/armani6.svg';
import sotheby from '../../images/sotheby.svg';
import arada from '../../images/arada.svg';
import backarrow from '../../images/back-arrow.svg';
import heart from '../../images/heart.svg';
import armanifr from '../../images/armani-fr.svg';

import arrowup from '../../images/arrow-up.svg';

function Details() {
    window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });  
    return (
        <>
            <section class="grid_box">
                <div class="container">
                    <div class="text_he_box">
                        <div class="row ">
                            <div class="col-md-6">
                                <div class="d-flex flex-wrap justify-content-between align-items-center pt-2 ">
                                    <h4><img src={backarrow} alt="" /> Properties for Sale <span>- Armani Beach Residences, Palm Jumeirah by Armani </span></h4>
                                    <h4>Verified Property</h4>
                                </div>
                            </div>
                            
                            <div class="col-md-6">
                                <div class="d-flex flex-wrap justify-content-between align-items-center px-5">
                                    <ul>
                                        <li><a href="#">Share <img src={arrowtopoutline} alt="" /></a></li>
                                        <li><a href="#">Save <img src={saveoutline} alt="" /></a></li>
                                        <li><a href="#">Like <img src={heartoutline} alt="" /></a></li>
                                    </ul>
                                    <a href="#" class="button_gredient">PUBLISH NOW</a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section class="middle_section">
                <div class="container">
                    <div class="row">
                        <div class="col-md-6">
                            <img class="box_frame" src={frame} width="100%" alt="" />
                            <div class="d-flex flex-wrap justify-content-between align-items-center text_he_box2">
                            <h4>Armani Beach Residences, Palm Jumeirah by Armani - Sunset View from Sea</h4>
                            <h4 class="text-end">View All Photos</h4>
                            </div>
                            <div class="d-flex photo_gal flex-wrap justify-content-between align-items-center mt-5">
                            <div class="col"> <img src={photo1} alt="" /> </div>
                            <div class="col"> <img src={photo2} alt="" /> </div>
                            <div class="col"> <img src={photo3} alt="" /> </div>
                            <div class="col"> <img src={photo4} alt="" /> </div>
                            <div class="col"> <img src={photo5} alt="" /> </div>
                            <div class="col"> <img src={photo6} alt="" /> </div>
                            <div class="col"> <img src={photo7} alt="" /> </div>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="box_bg_color right_side_box">
                            <h4>Armani Beach Residences, Palm Jumeirah by Armani</h4>
                            <span class="right_side_box_span"><img src={location} width="15px" alt="" /> Palm Jumeirah, Dubai - United Arab Emirates</span>
                            <div class="row justify-content-between">
                                <div class="col-md-5">
                                    <div class="hightlights">
                                        <div class="d-flex justify-content-between align-items-center">
                                        <h5>Highlights</h5>
                                        <span>PENTHOUSE</span>
                                        </div>
                                    </div>
                                    <div class="amanities">
                                        <ul>
                                        <li>Freehold |</li>
                                        <li>Villa |</li>
                                        <li>Swimming Pool |</li>
                                        <li>Parking |</li>
                                        <li>Downtown |</li>
                                        <li>Spa |</li>
                                        <li>Tennis |</li>
                                        <li> Children's Pool |</li>
                                        <li> Coffee |</li>
                                        <li> Lounge |</li>
                                        <li> Cinema </li>
                                        </ul>
                                    </div>
                                    <div class="box_blank"></div>
                                    <div class="most_links">
                                        <ul>
                                        <div class="d-flex justify-content-between">
                                            <li><a href="#"><img src={brochure} alt="" /> <br /> BROCHURE </a></li>
                                            <li><a href="#"><img src={floorplan} alt="" /> <br /> FLOOR PLAN </a></li>
                                            <li><a href="#"><img src={website} alt="" /><br /> WEBSITE </a></li>
                                        </div>
                                        </ul>
                                        <span class="border_radius_gredient"></span>
                                    </div>
                                </div>
                                <div class="col-md-5">
                                    <div class="hightlights hightlights_bor  mb-0">
                                        <div class="d-flex justify-content-between align-items-center">
                                        <h5>Price</h5>
                                        <span>SALE</span>
                                        </div>
                                    </div>
                                    <div class="aedprice">
                                        <h2>AED 482,500,000.00</h2>
                                        <div class="d-flex justify-content-between align-items-center">
                                        <span>Get this property </span>
                                        <a href="#" class="button_gredient">RESERVE NOW</a>
                                        </div>
                                    </div>
                                    <div class="most_links">
                                        <ul>
                                        <div class="d-flex justify-content-between">
                                            <li><a href="#"><img src={bedroom} alt="" /> <br /> 5 BEDROOMS </a></li>
                                            <li><a href="#"><img src={bathroom} alt="" /> <br /> 7 BATHROOMS </a></li>
                                            <li><a href="#"><img src={sqft} alt="" /><br /> 43,830 SQ FT</a></li>
                                        </div>
                                        </ul>
                                        <span class="border_radius_gredient"></span>
                                    </div>
                                </div>
                            </div>
                            </div>
                            <div class="sale_box">
                            <div class="row justify-content-between">
                                <div class="col-md-5">
                                    <div class="head_sale">
                                        <h6>Chat with your Broker</h6>
                                        <div class="sanda_box">
                                        <div class="d-flex justify-content-between align-items-center">
                                            <div class="pro-im-b"><img src={profile_img} alt="" />
                                                <span>sanda</span>
                                            </div>
                                            <div class="img_comment">
                                                <img src={comment} alt="" />
                                            </div>
                                        </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-5">
                                    <div class="profile_box pro-b2 text-center">
                                        <span>VERIFIED BROKER</span>
                                        <img src={profile_with_v} alt="" />
                                        <h5>sanda</h5>
                                        <h4>Sanda Ali</h4>
                                        <p>on Verified Properties since 1 May 2025</p>
                                    </div>
                                </div>
                            </div>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                    <span class="border_radius_gredient"></span>
                    </div>
                </div>
                <div class="armani_box">
                    <div class="container">
                        <div class="row">
                            <div class="col-md-6">
                            <div class="left_aside">
                                <h2>Armani Beach Residences, Palm Jumeirah by Armani</h2>
                                <span><img src={location} width="15px" alt="" /> Palm Jumeirah, Dubai - United Arab Emirates</span>
                                <div class="pri_sale d-flex">
                                    <h4>AED 482,500,000.00</h4>
                                    <h5>SALE</h5>
                                </div>
                                <div class="content_box">
                                    <h3>Luxury penthouse on Palm Jumeirah</h3>
                                    <br />
                                    <br />
                                    <p>It is hard to imagine a luxury property more impressive than this extraordinary five-bedroom Presidential penthouse apartment in the Armani Beach Residences, Palm Jumeirah. <br />
                                        <br />
                                        The Armani Beach Residences is one of Dubai's most anticipated luxury branded residences and its Presidential penthouse apartments represent the pinnacle of indulgent opulence. <br />
                                        <br />
                                        This expansive five-bedroom penthouse apartment has a meticulously designed interior by Armani/Casa and a host of state-of-the-art features that blend elegant style with contemporary functionality. <br />
                                        <br />
                                        The living areas are spacious and inviting, with unique detailing and stunning accents. The gourmet kitchen is equipped with the latest appliances, making both casual and formal dining a seamless experience. <br />
                                        <br />
                                        The penthouse spans a huge 43,830 sq. ft. and includes five generously proportioned bedrooms and seven bathrooms. <br />
                                        <br />
                                        As a Presidential penthouse, this apartment comes with an expansive roof terrace that has a large pool and a jacuzzi, al fresco dining area and breath-taking views over the Arabian Gulf and iconic Dubai skyline. <br />
                                        <br />
                                        The Armani Beach Residences on Palm Jumeirah have been designed to the highest standards, aiming to provide residents with everything they could possibly need to have an unforgettable living experience. <br />
                                        <br />
                                        The facilities are world-class with an exclusive private beach and lounger service, a contemplative courtyard designed by Tadao Ando, a luxury spa with sauna and ice bath, a cigar lounge, an indoor pool, a movie theatre and a large-scale infinity swimming pool. <br />
                                        <br />
                                        Due to be completed at the end of 2026, luxury property buyers will need to act fast in order to secure their own slice of tranquil luxury. <br />
                                        <br />
                                        If you would like to know more about this waterfront Presidential penthouse apartment on Palm Jumeirah, please get in touch with Dubai Sotheby's International Realty today.
                                    </p>
                                </div>
                            </div>
                            </div>
                            <div class="col-md-6">
                            <div class="gallery_gridview">
                                <div class="row">
                                    <div class="col-md-4 mb-4">
                                        <img src={armanifr} width="100%" alt="" />
                                    </div>
                                    <div class="col-md-4 mb-4">
                                        <img src={armani6} width="100%" alt="" />
                                    </div>
                                    <div class="col-md-4 mb-4">
                                        <img src={armani2} width="100%" alt="" />
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-md-4 mb-4">
                                        <img src={armani3} width="100%" alt="" />
                                    </div>
                                    <div class="col-md-4 mb-4">
                                        <img src={armani4} width="100%" alt="" />
                                    </div>
                                    <div class="col-md-4 mb-4">
                                        <img src={armani5} width="100%" alt="" />
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-md-4 mb-4">
                                        <img class="mb-4" src={armani1} width="100%" alt="" />
                                        <img src={armani3} width="100%" alt="" />
                                    </div>
                                    <div class="col-md-8">
                                        <img src={armani2} width="100%" alt="" />
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-md-4 mb-4">
                                        <img src={armani1} width="100%" alt="" />
                                    </div>
                                    <div class="col-md-4 mb-4">
                                        <img src={armani6} width="100%" alt="" />
                                    </div>
                                    <div class="col-md-4 mb-4">
                                        <img src={armani2} width="100%" alt="" />
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-md-4 mb-4">
                                        <img src={armani3} width="100%" alt="" />
                                    </div>
                                    <div class="col-md-4 mb-4">
                                        <img src={armani4} width="100%" alt="" />
                                    </div>
                                    <div class="col-md-4 mb-4">
                                        <img src={armani5} width="100%" alt="" />
                                    </div>
                                </div>
                            </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="bot_box">
                            <div class="d-flex flex-wrap justify-content-between align-items-center text_he_box">
                                <p>1 May 2025 - Verified Properties </p>
                                <ul>
                                    <li><a href="#">Share <img src={arrowup} alt="" /></a></li>
                                    <li><a href="#">Save <img src={save} alt="" /></a></li>
                                    <li><a href="#">Like <img src={heart} alt="" /></a></li>
                                </ul>
                                <p>Verified Property</p>
                            </div>
                            <span class="border_radius_gredient"></span>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section class="bottom_secton_box three_bottom_box">
                <div class="container">
                    <div class="row justify-content-between">
                        <div class="col-md-3">
                            <div class="agent_box">
                            <div class="d-flex justify-content-between align-items-center">
                                <h5>Your Agent</h5>
                                <span>VERIFIED</span>
                            </div>
                            <div class="profile_box text-center">
                                <img src={profile_with_v} alt="" />
                                <h5>sanda</h5>
                                <h4>Sanda Ali</h4>
                                <p>on Verified Properties since 1 May 2025</p>
                            </div>
                            <div class="share_three_box">
                                <div class="d-flex justify-content-between align-items-center">
                                    <a href="#" class="share_btn">SHARE</a>
                                    <a href="#"><img src={heart} alt="" /></a>
                                    <a href="#" class="chat_btn">CHAT</a>
                                </div>
                            </div>
                            </div>
                        </div>
                        <div class="col-md-3">
                            <div class="agent_box">
                            <div class="d-flex justify-content-between align-items-center">
                                <h5>Your Brokerage</h5>
                                <span>VERIFIED</span>
                            </div>
                            <div class="profile_box text-center">
                                <img src={sotheby} alt="" />
                                <h5>sothebys</h5>
                                <h4>Sotheby's International Realty</h4>
                                <p>on Verified Properties since 1 May 2025</p>
                            </div>
                            </div>
                        </div>
                        <div class="col-md-3">
                            <div class="agent_box">
                            <div class="d-flex justify-content-between align-items-center">
                                <h5>Your Developer</h5>
                                <span>VERIFIED</span>
                            </div>
                            <div class="profile_box text-center">
                                <img src={arada} alt="" />
                                <h5>arada</h5>
                                <h4>Arada Developments LLC</h4>
                                <p>on Verified Properties since 1 May 2025</p>
                            </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <div class="stripbo">
                <div class="container">
                    <div class="row">
                    <span class="border_radius_gredient"></span>
                        <h4>Verified Properties - United Arab Emirates - Buy - Properties for Sale - Armani Beach Residences, Palm Jumeirah by Armani - 12011768 </h4>
                    </div>
                </div>
            </div>
        </>
    );
}

export default Details;